// extracted by mini-css-extract-plugin
module.exports = {"container":"textarea_container__1buQt","error":"textarea_error__11wQ5","label":"textarea_label__3TlNn"};